// Halaman gerbang UJIAN. Dilabel jelas — tiada wang sebenar. Tidak wujud dalam production.

import { html, mount } from '../core/html.js';
import { get, post } from '../core/api.js';
import { withBusy, statusBadge } from '../core/ui.js';
import { rm } from '../core/format.js';
import { t } from '../core/i18n.js';
import { navigate } from '../app.js';

export async function render(main, { ref }) {
  const p = await get(`/api/sandbox/payments/${ref}`);
  mount(main, html`<div class="wrap"><div class="sandbox">
    <span class="warnhead">${t('sandbox.badge')}</span>
    <h1>${t('sandbox.title')}</h1>
    <p>${t('sandbox.text')}</p>
    <div class="panel soft"><div class="spread"><span data-ugc>${p.property_name}</span><b>${rm(p.amount_minor)}</b></div><div class="small muted">${t('booking.ref', { id: p.booking_id })} ${statusBadge(p.status)}</div></div>
    ${p.status === 'PENDING' ? html`<div class="row" style="margin-top:16px"><button class="btn btn-primary" id="ok">${t('sandbox.approve')}</button><button class="btn btn-ghost" id="no">${t('sandbox.fail')}</button></div>` : html`<a class="btn btn-primary" style="margin-top:16px" href="#/payment-return/${p.payment_id}">${t('common.continue')}</a>`}
  </div></div>`);
  const go = (outcome) => (e) => withBusy(e.currentTarget, async () => {
    await post(`/api/sandbox/payments/${ref}/complete`, { outcome });
    navigate(`/payment-return/${p.payment_id}`);
  });
  main.querySelector('#ok')?.addEventListener('click', go('success'));
  main.querySelector('#no')?.addEventListener('click', go('fail'));
}
